import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  CuralateProduct,
  useProductContext,
} from '~/techstyle-shared/react-components';
import { ProductType } from '~/techstyle-shared/react-products';

const ContentUGC = styled.div`
  padding-bottom: 16px;
`;

const mensCategoryId = config.get('public.productCategories.mens');

const ProductDetailUGC = ({
  product: productFromProps,
  experienceName = '',
}) => {
  const productFromContext = useProductContext();
  const product = productFromProps || productFromContext;
  const defaultPdpExperienceName = config.get(
    'public.curalate.defaultPdpExperienceName'
  );

  let experienceNameToShow;
  if (!experienceName?.length) {
    experienceNameToShow = defaultPdpExperienceName;
    const isBundle = product.productTypeId === ProductType.BUNDLE;
    const categoryIdList = isBundle
      ? product.bundleComponentProducts[0].productCategoryIdList
      : product.productCategoryIdList;
    const isMens = categoryIdList.includes(mensCategoryId);
    if (isMens) {
      experienceNameToShow = 'custom-product-mens';
    }
  } else {
    experienceNameToShow = experienceName;
  }

  return (
    <ContentUGC>
      <CuralateProduct
        experienceName={experienceNameToShow}
        product={product}
      />
    </ContentUGC>
  );
};

ProductDetailUGC.propTypes = {
  experienceName: PropTypes.string,
  product: PropTypes.object,
};

export default ProductDetailUGC;
